import * as React from "react";
import styled from "@mui/material/styles/styled";
import { makeStyles } from "@mui/styles";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { ForwardedRef, Ref } from "react";
const MobileView = "xs"; // TODO: move to common;
//region [[ Styles ]]

const ANIMATION_DURATION = "400ms";

const transformFrom = { opacity: 1, top: "-3px" };
const transformTo = { opacity: 0, top: "3px" };

const ThreeDotsLoaderView = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  marginTop: "15px",
  [theme.breakpoints.down(MobileView)]: {
    marginTop: "30px",
  },
  width: "100%",
}));

const DotsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "row",
  width: "40px",
  justifyContent: "space-between",
}));

const usePulse = makeStyles({
  "@keyframes pulse1": {
    from: transformFrom,
    to: transformTo,
  },
  "@keyframes pulse2": {
    from: transformFrom,
    to: transformTo,
  },
  "@keyframes pulse3": {
    from: transformFrom,
    to: transformTo,
  },
  pulse1: {
    animationName: "$pulse1",
    animationDuration: ANIMATION_DURATION,
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out",
  },
  pulse2: {
    animationName: "$pulse2",
    animationDuration: ANIMATION_DURATION,
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationDelay: "100ms",
    animationTimingFunction: "ease-in-out",
  },
  pulse3: {
    animationName: "$pulse3",
    animationDuration: ANIMATION_DURATION,
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationDelay: "200ms",
    animationTimingFunction: "ease-in-out",
  },

  withAnimation: ({ disabled }: { disabled: boolean }) => ({
    animationPlayState: disabled ? "paused" : "running",
  }),
});

const SingleDot = styled("div")(({ color }: { color: string }) => ({
  width: "10px",
  height: "10px",
  borderRadius: "5px",
  backgroundColor: color ? color : KahunColorMap.PrimaryDim,
  position: "relative",
  color: "#9880ff",
}));

const LoaderScrollAnchor = styled("div")(() => ({}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ThreeDotsLoaderProps {
  id?: string;
  className?: string;
  color?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ThreeDotsTypingLoader = React.forwardRef(
  ({ ...props }: ThreeDotsLoaderProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { pulse1, pulse2, pulse3, withAnimation } = usePulse({
      disabled: false,
    });

    return (
      <ThreeDotsLoaderView
        className={props.className}
        id={props.id || "loading"}
      >
        <DotsContainer className={"dots-container"}>
          <SingleDot
            className={`${pulse1} ${withAnimation}`}
            color={props.color}
          />
          <SingleDot
            className={`${pulse2} ${withAnimation}`}
            color={props.color}
          />
          <SingleDot
            className={`${pulse3} ${withAnimation}`}
            color={props.color}
          />
        </DotsContainer>
        <LoaderScrollAnchor ref={ref} className={"anchor"} />
      </ThreeDotsLoaderView>
    );
  },
);
